import React from "react";
import { IconProps } from "../icon";

export const ReverseLeftIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 7h10a6 6 0 010 12H4M4 7l4-4M4 7l4 4"
    />
  </svg>
);
